import { findDOMNode } from 'react-dom';
import smoothscroll from 'smoothscroll-polyfill';

// kick off the polyfill!
smoothscroll.polyfill();

export default function scrollToReactComponent(component, noAnimation) {
  let htmlElement =
    component && component.props ? findDOMNode(component) : component;
  if (!htmlElement) {
    console.error(`Could not find element`);
    return;
  }
  window.scroll({
    top: htmlElement.offsetTop,
    left: 0,
    behavior: noAnimation ? 'auto' : 'smooth',
  });
}



// WEBPACK FOOTER //
// ./src/helpers/scroll-to-component.js